import * as local from "./local";
import * as session from "./session";

const storage = { local, session };
export default storage;
